module.exports = __webpack_public_path__ + "media/app/images/microphone-icon-1cbc5175ea9426cfafffa600aafb83c1.png";